import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, createVNode as _createVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8b30af3c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "TAtividades",
  "data-testid": "TAtividades"
}
const _hoisted_2 = { class: "TAtividades__Nav" }
const _hoisted_3 = { class: "TAtividades__Body" }
const _hoisted_4 = { class: "TAtividades__Main" }

interface Props {
    exibirSidebar: boolean
  }
  
export default /*#__PURE__*/_defineComponent({
  __name: 'TAtividades',
  props: {
    exibirSidebar: { type: Boolean }
  },
  setup(__props: any) {

  

return (_ctx: any,_cache: any) => {
  const _component_sidebar = _resolveComponent("sidebar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("nav", _hoisted_2, [
      _renderSlot(_ctx.$slots, "navegacao")
    ]),
    _createElementVNode("main", _hoisted_3, [
      _createVNode(_Transition, null, {
        default: _withCtx(() => [
          (__props.exibirSidebar)
            ? (_openBlock(), _createBlock(_component_sidebar, {
                key: 0,
                class: "TAtividades__Sidebar",
                "data-testid": "TAtividades__Sidebar"
              }, {
                default: _withCtx(() => [
                  _renderSlot(_ctx.$slots, "sidebar")
                ]),
                _: 3
              }))
            : _createCommentVNode("", true)
        ]),
        _: 3
      }),
      _createElementVNode("main", _hoisted_4, [
        _renderSlot(_ctx.$slots, "centro")
      ]),
      _renderSlot(_ctx.$slots, "modais")
    ])
  ]))
}
}

})